import reducer from './reducer'

import * as assignmentListSelectors from './selectors'

export { assignmentListSelectors }

export default reducer
